import React, { useState } from 'react'
import styled from 'styled-components'
import { Layout, Popover } from 'antd'

import { FlexColumn } from './FlexboxReusables/FlexItems'
import type { Base64ImageUrl, CoursePage } from './Course/types'
import { View } from '../Routes/Course'
import LoadingSpinner from './LoadingSpinner'
import { imageUrl } from '../globals'

const { Sider } = Layout

interface SidebarProps {
  pages: Array<CoursePage>;
  selectedPage: number;
  setSelectedPage: (page: number) => void
  setSelectedView: (view: View) => void
  loadingCourse: boolean
  cacheBust?: number
}

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { pages, selectedPage, setSelectedPage, setSelectedView, loadingCourse, cacheBust } = props

  const [collapsed, setCollapsed] = useState(false)

  // blank white image to display if no preview picture is available (for new courses/pages)
  const defaultImageSrc = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='

  const srcFor = (p: CoursePage) =>
    p.previewPicture || `${imageUrl}/${p.courseId}/${p.pageNumber}.jpg${cacheBust ? `?v=${cacheBust}` : ''}`

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      collapsedWidth={40}
      onCollapse={(value) => setCollapsed(value)}
      style={{ height: '94vh', overflowY: 'scroll', zIndex: 999, padding: '1em 0' }}
    >
      {!loadingCourse ? (
        <div style={{ paddingBottom: '3vh' }}>
          {!collapsed && pages.map((page) => (
            <FlexColumn height='10em' margin='5px' width='95%' key={page.pageNumber}>
              <Popover
                placement='right'
                content={
                  <BigPreviewPicture
                    alt=""
                    src={srcFor(page)} />
                }
                trigger='hover'
                mouseEnterDelay={1}
              >
                <PreviewImage
                  alt=""
                  src={srcFor(page)}
                  currentlySelected={selectedPage === (page.pageNumber - 1)}
                  onClick={() => {
                    setSelectedPage(page.pageNumber - 1)
                    setSelectedView(View.EDITOR)
                  }}
                  onError={(e) => {
                    e.currentTarget.onerror = null // prevent infinite loop
                    e.currentTarget.src = defaultImageSrc
                  }}
                />
              </Popover>
              <PageNumber>
                {page.pageNumber}
              </PageNumber>
            </FlexColumn>
          ))}
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </Sider>
  )
}

export default Sidebar

const PreviewImage = styled.img<{ src: Base64ImageUrl; currentlySelected: boolean }>`
  width: 85%;
  height: 80%;
  border-radius: 0.35em;
  border: ${({ currentlySelected }) => currentlySelected ? '2px double red' : 'none'};
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 2px 4px rgba(234, 225, 225, 0.5);
  background-color: white;

  &:hover {
  transform: scale(1.1);
    border: 2px double #14CCAA;
  }
`

const BigPreviewPicture = styled.img`
  width: 50vw;
  height: 30vh;
  object-fit: fill;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  box-shadow: 2px 2px 4px rgba(234, 225, 225, 0.5);
`

const PageNumber = styled.div`
  color: white;
  margin: 5px 0;
`